import {
  Box,
  Flex,
  Select,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Button,
  Stack,
  Spinner,
  Badge,
  useColorModeValue,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Grid,
  GridItem,
  Icon,
  Avatar,
} from "@chakra-ui/react";
import { FaSync, FaPrint, FaClock, FaBook } from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { MdSchool, MdPeople, MdPerson } from "react-icons/md";

import { Doughnut } from "react-chartjs-2";
import ExamDetails from "./ExamDetails";
import Print_pdf_classDetails from "./Print_pdf_classDetails";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const IndividualClass = () => {
  const classId = localStorage.getItem("class");
  const [visibleStudents, setVisibleStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchField, setSearchField] = useState("name");
  const [searchTerm, setSearchTerm] = useState("");
  const [genderCounts, setGenderCounts] = useState({ male: 0, female: 0 });
  const [totalStudents, setTotalStudents] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [timetable, setTimetable] = useState([]);
  const [days, setDays] = useState([]); // State for days
  const [loadingTimetable, setLoadingTimetable] = useState(true);
  const [classData, setClassData] = useState([]);
  const [classDetails, setClassDetails] = useState(null);

  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const printComponentRef = useRef();
  // Fetch assigned students for the class
  useEffect(() => {
    if (classId) {
      setLoading(true);
      axios
        .get(
          `${BASE_URL}/admin/class/list_assigned_students.php?class_details_id=${classId}`
        )
        .then((response) => {
          const { data, student_count, gender } = response.data;
          setVisibleStudents(data || []);
          setTotalStudents(student_count);
          setIsDataLoaded(true); // Mark data as loaded

          const maleCount = gender.find((g) => g.gender === "Male")?.count || 0;
          const femaleCount =
            gender.find((g) => g.gender === "Female")?.count || 0;
          setGenderCounts({ male: maleCount, female: femaleCount });
        })
        .catch((error) => {
          console.error("Error fetching students:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [classId]);

  const darkColors = ["yellow.800", "green", "black", "red.600", "pink.900"];

  // Fetch timetable and days data using POST
  useEffect(() => {
    const selectedClass = localStorage.getItem("classId");
    const selectedDivision = localStorage.getItem("divisionId");
    console.log(selectedDivision);
    console.log(selectedClass);

    if (selectedClass && selectedDivision) {
      setLoadingTimetable(true);

      // Fetch timetable data
      axios
        .post(
          `${BASE_URL}/admin/timetable/list_all_time_table.php`,
          {
            class_id: selectedClass,
            division_id: selectedDivision,
          }
        )
        .then((response) => {
          console.log("API Response:", response);

          if (response.data.error) {
            setSubjects([]);
            setTimetable([]);
          } else {
            // Assuming response.data.data contains timetable information
            const timetableData = response.data.data.map((item) => ({
              subject: item.subject, // Subject name
              staffName: item.name, // Teacher's name
              startTime: item.start_time,
              endTime: item.end_time,
              day: item.day,
              imageUrl: item.image_url, // Teacher's image URL
            }));

            setTimetable(timetableData);

            // Map subjects and teachers for separate display and remove duplicates
            const subjectData = timetableData.map((item) => ({
              subject: item.subject,
              staffName: item.staffName,
            }));

            // Remove duplicates using `filter`
            const uniqueSubjects = subjectData.filter(
              (value, index, self) =>
                index ===
                self.findIndex(
                  (t) =>
                    t.subject === value.subject &&
                    t.staffName === value.staffName
                )
            );

            setSubjects(uniqueSubjects);
          }
        })
        .catch((error) => {
          console.error("Error fetching timetable:", error);
        })
        .finally(() => {
          setLoadingTimetable(false);
        });

      // Fetch days data
      axios
        .get(`${BASE_URL}/admin/timetable/day_master.php`)
        .then((response) => {
          setDays(response.data.data || []);
        })
        .catch((error) => {
          console.error("Error fetching days:", error);
        });
    }
  }, []);

  const handlePrint = () => {
    // Only trigger print if data is fully loaded
    if (isDataLoaded && printComponentRef.current) {
      printComponentRef.current.handlePrint();
    } else {
      console.log("Data is still loading...");
    }
  };
  // Pagination logic for students
  const currentData = visibleStudents.slice(
    (currentPage - 1) * rowsPerPage,
    (currentPage - 1) * rowsPerPage + rowsPerPage
  );

  const totalPages = Math.ceil(visibleStudents.length / rowsPerPage);

  const renderRow = (student) => (
    <Tr key={student.id}>
      <Td>{student.admission_number}</Td>
      <Td py="12px" px="20px" textAlign="left">
        <Link
          to={`/students/detail/${student.user_id}`}
          style={{ display: "flex", alignItems: "center", gap: "10px" }}
        >
          <Text>{student.name}</Text>
        </Link>
      </Td>
      <Td>{student.father_name}</Td>
      <Td>{student.mother_name}</Td>
      <Td py="12px" px="20px" textAlign="left">
        <Badge
          colorScheme={student.status === "Present" ? "green" : "green"}
          borderRadius="full"
          px={4}
          py={1}
          fontSize="11px"
          boxShadow="md"
          position="relative"
        >
          {student.status === "Present" ? "Present" : "Present"}
        </Badge>
      </Td>
    </Tr>
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  const [classTeacherName, setClassTeacherName] = useState("");
  const [leaderName, setLeaderName] = useState("");
  // Define a color array for timetable slots
  const colors = ["#F7E1D7", "#D1E8E4", "#E1F7D7", "#D7E1F7", "#F7D7E1"];
  const [subjects, setSubjects] = useState([]);
  // const colors = ["#FF6347", "#7FFF00", "#00BFFF", "#8A2BE2", "#FF1493"];
  // Define the helper function before the component
  const calculateColumns = (totalSubjects) => {
    if (totalSubjects % 5 === 0) return totalSubjects / 5;
    if (totalSubjects % 4 === 0) return totalSubjects / 4;
    if (totalSubjects % 3 === 0) return totalSubjects / 3;
    return 3; // Default to 3 columns
  };

  const columns = calculateColumns(subjects.length);

  const chartOptions = {
    plugins: {
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            return `${tooltipItem.label}: ${tooltipItem.raw}`;
          },
        },
      },
    },
    maintainAspectRatio: false,
  };
  const chartData = {
    labels: ["Female", "Male"],
    datasets: [
      {
        data: [genderCounts.female, genderCounts.male],
        backgroundColor: ["#4FD1C5", "#4299E1"], // Colors for Female and Male
        hoverBackgroundColor: ["#38B2AC", "#3182CE"],
      },
    ],
  };
  useEffect(() => {
    if (classId) {
      axios
        .get(
          `${BASE_URL}/admin/class/list_single_class.php?class_details_id=${classId}`
        )
        .then((response) => {
          const data = response.data;
          console.log("hi", data);

          setClassTeacherName(data.data.ClassTeacher || "Not Assigned");
          console.log("ss", classTeacherName);

          setLeaderName(data.data.ClassLeader || "Not Assigned");
        })
        .catch((error) =>
          console.error("Error fetching class details:", error)
        );
    }
  }, [classId]);

  return (
    <Box maxWidth="100%">
      <div className="teacher-list-container">
        <div
          className="header"
          style={{ display: "flex", alignItems: "center" }}
        >
          <h1 style={{ fontSize: "20px", margin: 0 }}>Class Details</h1>
          <div className="action-buttons" style={{ marginLeft: "auto" }}>
            {/* <Button
              className="refresh-button"
              boxShadow="md"
              backgroundColor="white"
              fontSize="11px"
              onClick={() => {
                console.log("Refresh button clicked");
              }}
              display={{ base: "none", md: "flex" }}
            >
              <FaSync color="#515B73" />
            </Button> */}
            <div className="export-dropdown">
              <Button
                className="export-button"
                display={{ base: "none", md: "flex" }}
                backgroundColor="white"
                fontSize="11px"
                boxShadow="md"
                onClick={handlePrint} // Attach the print handler here
              >
                <FaPrint color="#515B73" />
                Print PDF
              </Button>
            </div>
          </div>
        </div>

        <Box className="breadcrumb">
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Class </span> /
          <Link
            to="/class/classlist"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Class List</span>
          </Link>
          / <span>Class Details </span>
        </Box>
      </div>

      <div style={{ display: "none" }}>
        <Print_pdf_classDetails
          ref={printComponentRef}
          classDetails={classDetails}
        />
      </div>

      {/* Display class tr ,leader ,graph Gender Count */}
      <Box maxWidth="100%" padding={5}>
        <Box
          width="100%"
          maxW="1200px"
          mx="auto"
          p={6}
          border="2px solid"
          borderColor={useColorModeValue("teal.300", "teal.600")}
          borderRadius="lg"
          boxShadow="lg"
          bgGradient="linear(to-br, teal.100, blue.50)"
          textAlign="center"
          transition="transform 0.2s"
        >
          <Flex
            direction={{ base: "column", md: "row" }}
            justify="space-between"
            wrap="nowrap"
          >
            {/* Class Teacher and Leader */}
            <Box
              width={{ base: "100%", md: "30%" }} // Adjust width as needed
              textAlign="left"
            >
              <Text fontSize="md" fontWeight="bold" color="teal.600" mb={2}>
                <Icon as={MdSchool} boxSize={4} mr={2} /> Class Teacher
              </Text>
              <Text fontSize="sm" color="black" mb={4} ml={7}>
                {classTeacherName}
              </Text>
              <Text fontSize="md" fontWeight="bold" color="teal.600" mb={2}>
                <Icon as={MdPerson} boxSize={4} mr={2} /> Leader
              </Text>
              <Text fontSize="sm" color="black" ml={7}>
                {leaderName}
              </Text>
            </Box>

            {/* List of Subjects and Teachers in Grid */}
            <Grid
              templateColumns={`repeat(${columns}, 1fr)`}
              gap={4}
              width="100%"
            >
              {subjects.map((subject, index) => (
                <Box key={index} display="flex" alignItems="center" mb={4}>
                  <Box
                    width="12px"
                    height="12px"
                    bg={
                      darkColors[Math.floor(Math.random() * darkColors.length)]
                    }
                    mr={3}
                  />
                  <Text fontSize="sm" color="black">
                    {subject.subject} - {subject.staffName}
                  </Text>
                </Box>
              ))}
            </Grid>
            {/* Total Strength and Donut Chart */}
            <Box
              width={{ base: "100%", md: "25%" }} // Adjust width as needed
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Box width="200px" height="200px">
                <Doughnut
                  data={chartData}
                  options={{ maintainAspectRatio: false }}
                />
                <Text fontSize="sm" fontWeight="bold" color="teal.600">
                  Total Strength: {totalStudents}
                </Text>
              </Box>
            </Box>
          </Flex>
        </Box>
      </Box>

      <Box p={6} flex="2" mb={9}>
        <Tabs
          variant="soft-rounded"
          colorScheme="teal"
          isFitted
          p={2}
          borderRadius="md"
          bg={useColorModeValue("white", "gray.700")}
        >
          <TabList>
            <Tab
              _selected={{
                bg: useColorModeValue("teal.100", "teal.600"),
                color: "teal.800",
                fontWeight: "bold",
                borderRadius: "md",
              }}
              py={2}
            >
              Student List
            </Tab>
            <Tab
              _selected={{
                bg: useColorModeValue("teal.100", "teal.600"),
                color: "teal.800",
                fontWeight: "bold",
                borderRadius: "md",
              }}
              py={2}
            >
              Timetable
            </Tab>
            <Tab
              _selected={{
                bg: useColorModeValue("teal.100", "teal.600"),
                color: "teal.800",
                fontWeight: "bold",
                borderRadius: "md",
              }}
              py={2}
            >
              Exam Details
            </Tab>
          </TabList>

          <TabPanels>
            {/* Student List Tab */}
            <TabPanel p={1}>
              <Box flex="1">
                <Flex
                  direction="row"
                  justify="space-between"
                  align="center"
                  p={3}
                  className="sb"
                >
                  <Flex direction="row" align="center">
                    <Text mr={2}>Rows Per Page</Text>
                    <Select
                      width="100px"
                      value={rowsPerPage}
                      onChange={(e) => setRowsPerPage(Number(e.target.value))}
                      borderColor="#E9EDF4"
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                    </Select>
                  </Flex>
                </Flex>
                <div style={{ overflowX: "auto" }}>
                  <Table
                    sx={{
                      "tbody tr:nth-of-type(even)": {
                        backgroundColor: "#f2f4f8",
                      },
                    }}
                  >
                    <Thead>
                      <Tr>
                        <Th>Admission No</Th>
                        <Th>Name</Th>
                        <Th>Father's Name</Th>
                        <Th>Mother's Name</Th>
                        <Th>Status</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {loading ? (
                        <Tr>
                          <Td colSpan={5}>
                            <Flex justify="center">
                              <Spinner size="lg" />
                            </Flex>
                          </Td>
                        </Tr>
                      ) : (
                        currentData.map(renderRow)
                      )}
                    </Tbody>
                  </Table>
                </div>
                <Flex justify="end" align="center" p={3} className="sb2">
                  <Button
                    onClick={() => handlePageChange(currentPage - 1)}
                    isDisabled={currentPage === 1}
                  >
                    Prev
                  </Button>
                  <Stack direction="row" spacing={2} mx={2}>
                    {Array.from({ length: totalPages }, (_, i) => (
                      <Button
                        key={i}
                        onClick={() => handlePageChange(i + 1)}
                        colorScheme={currentPage === i + 1 ? "teal" : "gray"}
                      >
                        {i + 1}
                      </Button>
                    ))}
                  </Stack>
                  <Button
                    onClick={() => handlePageChange(currentPage + 1)}
                    isDisabled={currentPage === totalPages}
                  >
                    Next
                  </Button>
                </Flex>
              </Box>
            </TabPanel>

            {/* Timetable Tab */}
            <TabPanel p={1}>
              {loadingTimetable ? (
                <Flex justify="center">
                  <Spinner size="lg" />
                </Flex>
              ) : (
                <Grid
                  templateColumns={{
                    base: "repeat(1, 1fr)",
                    md: "repeat(3, 1fr)",
                    lg: "repeat(5, 1fr)",
                  }}
                  gap={6}
                  mt={1}
                  p={4}
                >
                  {days.map((day) => (
                    <GridItem key={day.id}>
                      <Text fontWeight="bold" mb={3}>
                        {day.day}
                      </Text>
                      {timetable
                        .filter((slot) => slot.day === day.day)
                        .map((slot, j) => (
                          <Box
                            key={j}
                            bg={
                              colors[Math.floor(Math.random() * colors.length)]
                            }
                            p={4}
                            borderRadius="md"
                            mb={4}
                          >
                            <Flex alignItems="center" mb={2}>
                              <Icon as={FaClock} color="gray.500" mr={2} />
                              <Text>
                                {slot.startTime} - {slot.endTime}
                              </Text>
                            </Flex>
                            <Flex alignItems="center" mb={2}>
                              <Icon as={FaBook} color="gray.500" mr={2} />
                              <Text>Subject: {slot.subject}</Text>
                            </Flex>
                            <Flex alignItems="center">
                              <Avatar src={slot.imageUrl} size="sm" mr={2} />
                              <Text>{slot.staffName}</Text>
                            </Flex>
                          </Box>
                        ))}
                    </GridItem>
                  ))}
                </Grid>
              )}
            </TabPanel>

            {/* Exam Details Tab */}
            <TabPanel p={1}>
              <ExamDetails />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </Box>
  );
};

export default IndividualClass;
